export default {
	list: 'Correction',
	columns: {
		Id: {
			class: 'id',
			dataName: 'Id',
			type: 'number',
			title: 'Id',
			width: 100,
			hidden: true
		},
		Status: {
			class: 'choice',
			dataName: 'Status',
			type: 'string',
			title: 'Status',
			width: 100,
			hidden: false
		},
		BusinessEvent: {
			class: 'value',
			dataName: 'BusinessEvent',
			type: 'string',
			title: 'Business Event',
			width: 180,
			hidden: false
		},
		CorrectionID: {
			class: 'value',
			dataName: 'CorrectionID',
			type: 'number',
			title: 'Correction Id',
			width: 100,
			hidden: true
		},
		ProgramId: {
			class: 'lookup',
			dataName: 'ProgramId',
			type: 'number',
			title: 'Program Id',
			width: 100,
			hidden: true
		},
		ProgramTitle: {
			class: 'lookup',
			dataName: 'Program/Title',
			type: 'string',
			title: 'Program',
			width: 200,
			hidden: false,
			readOnly: true
		},
		SenderId: {
			class: 'lookup',
			dataName: 'SenderId',
			type: 'number',
			title: 'Sender Id',
			width: 100,
			hidden: true
		},
		SenderFullName: {
			class: 'lookup',
			dataName: 'Sender/FullName',
			type: 'string',
			title: 'Sender Name',
			width: 180,
			hidden: false,
			readOnly: true
		},
		ReceiverId: {
			class: 'lookup',
			dataName: 'ReceiverId',
			type: 'number',
			title: 'Receiver Id',
			width: 100,
			hidden: true
		},
		ReceiverFullName: {
			class: 'lookup',
			dataName: 'Receiver/FullName',
			type: 'string',
			title: 'Receiver Name',
			width: 180,
			hidden: false,
			readOnly: true
		},
		NonAffiliateTransfer:{
			class: 'value',
			dataName: 'NonAffiliateTransfer',
			type: 'boolean',
			title: 'NonAffiliateTransfer',
			width: 100,
			hidden: true
		},
		UnitClass: {
			class: 'choice',
			dataName: 'UnitClass',
			type: 'string',
			title: 'Unit Class',
			width: 150,
			hidden: false
		},
		UnitType: {
			class: 'choice',
			dataName: 'UnitType',
			type: 'string',
			title: 'Unit Type',
			width: 150,
			hidden: false
		},
		VestingType: {
			class: 'choice',
			dataName: 'VestingType',
			type: 'string',
			title: 'Vesting Type',
			width: 150,
			hidden: false
		},
		UnitPool: {
			class: 'choice',
			dataName: 'UnitPool',
			type: 'string',
			title: 'UnitPool',
			width: 150,
			hidden: false
		},
		Unit: {
			class: 'value',
			dataName: 'Unit',
			type: 'number',
			title: 'Vesting Base Units',
			width: 120,
			hidden: true,
			template: '<span class="number-cell-ui">#=kendo.format("{0:n2}", Unit )#</span>'
		},
		VestStartDate: {
			class: 'value',
			dataName: 'VestStartDate',
			type: 'date',
			title: 'Vesting Start Date',
			filterable: true,
			width: 220,
			hidden: true
		},
		Year: {
			class: 'value',
			dataName: 'Year',
			type: 'number',
			title: 'Vesting Year',
			filterable: true,
			width: 180,
			hidden: true
		},
		VestedDate: {
			class: 'value',
			dataName: 'VestedDate',
			type: 'date',
			title: 'Vesting Date',
			filterable: true,
			width: 180,
			hidden: false
		},
		Percentage: {
			class: 'value',
			dataName: 'Percentage',
			type: 'percent',
			format: '{0:p}',
			title: 'Vesting Percentage',
			template: '<span class="number-cell-ui">#=kendo.toString(Percentage, "p1")#</span>',
			filterable: true,
			width: 180,
			hidden: false
		},
		VestedUnit: {
			class: 'value',
			dataName: 'VestedUnit',
			type: 'number',
			title: 'Vesting Units',
			filterable: true,
			template: '<span class="number-cell-ui">#=kendo.format("{0:n2}", VestedUnit )#</span>',
			width: 180,
			hidden: false
		},
		SpecialArrangement: {
			class: 'value',
			dataName: 'SpecialArrangement',
			type: 'string',
			title: 'Special Vesting',
			filterable: true,
			width: 180,
			hidden: false
		},
		TransactionDate: {
			class: 'value',
			dataName: 'TransactionDate',
			type: 'date',
			title: 'Date',
			filterable: true,
			width: 100,
			hidden: true
		},
		Note: {
			class: 'value',
			dataName: 'Note',
			type: 'string',
			title: 'Note',
			width: 100,
			hidden: true
		},
		BatchGUID: {
			class: 'value',
			dataName: 'BatchGUID',
			type: 'string',
			title: 'Batch Id',
			width: 100,
			hidden: true
		},
		CorrectionDate:{
			class: 'value',
			dataName: 'CorrectionDate',
			type: 'date',
			title: 'Date',
			filterable: true,
			width: 100,
			hidden: true
		}
	}
}